module.exports = __webpack_public_path__ + "img/back.a6a829fc.svg";